module.exports = "<p>באמצעות לחצן האפשרויות נוספות, שבשורת החיפוש בעמוד הבית, תוכלו לסמן את סוג הנכס שאתם מחפשים, מספר החדרים והסכום המשוער שאתם מוכנים לשלם. כל אחד מהפילטרים הללו יביא לכך שהתוצאות שתקבלו יהיו מצומצמות יותר ויחסוך סחרחורת של עודף אפשרויות שאינן רלוונטיות עבורכם. רוצים לסנן את התוצאות עוד יותר? לחצו על לחצן הסינון שמופיע מעל רשימת הנכסים שהעלה החיפוש. עדיין לא מספיק? תוכלו לסנן עוד יותר באמצעות לחצן הסינון המתקדם שבתחתית החלון שיפתח לכם.</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/translations/help/he/10.md
// module id = 808
// module chunks = 0